
    import { defineComponent } from 'vue'
    import { buildLocalization } from '@/util'
    import LinkButton from '@/components/common/link-button.vue'

    export default defineComponent({
        name: 'BrowseSparePartCatalog',

        components: {
            LinkButton
        },

        setup() {
            const { localize } = buildLocalization()

            return { localize }
        }
    })
